/**
 * Shared commercial outcome scale used by recommendation learning and reporting.
 * It is deliberately ordinal, not a claimed monetary ROI score.
 */
export function commercialOutcomePoints(outcome) {
    switch (outcome) {
        case 'project-won': return 10;
        case 'brief-received': return 7;
        case 'meeting-booked': return 5;
        case 'reply-positive': return 3;
        case 'reply-neutral':
        case 'reply-detected': return 1;
        default: return 0;
    }
}
export function evidenceConfidence(sample) {
    return sample < 5 ? 'early' : sample < 15 ? 'building' : sample < 30 ? 'medium' : 'strong';
}
export function isHumanReplySequence(row) {
    if (row.replyClassification === 'automatic' || row.outcome === 'out-of-office')
        return false;
    return ['reply-detected', 'reply-positive', 'reply-neutral', 'not-interested', 'meeting-booked', 'brief-received', 'project-won', 'not-now'].includes(row.outcome);
}
export function sequenceCommercialPoints(row) {
    return commercialOutcomePoints(row.outcome);
}
export function commercialSignal(rows) {
    const sent = rows.filter(row => row.stage === 'sent');
    const points = sent.reduce((sum, row) => sum + sequenceCommercialPoints(row), 0);
    return { sample: sent.length, points, average: sent.length ? points / sent.length : 0, confidence: evidenceConfidence(sent.length) };
}
